<template>
    <pop-open-box v-slot="{ closePopup }" name="contact-form" class="flex flex-col justify-center items-center contact-form"
                  @close-popup="popupClosed"
                  :screen-height="true">
        <div class="w-full max-w-md bg-brand-gray-300 p-4 rounded-lg relative mt-10 mb-10">
            <button class="block text-right text-brand-gray-500 text-2xl absolute top-0 right-0 mr-6 mt-2" @click.prevent="closePopup">X</button>
            <h2 class="text-brand-gray-600 text-center text-2xl font-bold mb-4">Hello</h2>
            <h3 class="text-brand-gray-600 text-center text-lg mb-8">What can we help you with?</h3>
            <form class="max-w-md mx-auto" @submit.prevent="submit(closePopup)">
                <div class="mb-4">
                    <label class="block text-brand-gray-700 text-sm font-bold mb-2 sr-only" for="contactName">
                        Your Name
                    </label>
                    <div class="shadow border rounded-full w-full py-3 px-3 text-brand-gray-700 bg-white flex items-center"
                         :class="{'border-red-500': errors.hasOwnProperty('contactName')}"
                    >
                        <i class="fas fa-user text-orange-600"></i>
                        <input class="border-none focus:border-none appearance-none leading-tight focus:outline-none ml-4 placeholder-brand-gray-600 w-full"
                               v-model="form.contactName"
                               required
                               id="contactName" type="text" placeholder="Your Name">
                    </div>
                    <p class="text-red-500 text-xs italic" v-if="errors.hasOwnProperty('contactName')">{{errors.contactName}}</p>
                </div>
                <div class="mb-4">
                    <label class="block text-brand-gray-700 text-sm font-bold mb-2 sr-only" for="contactEmail">
                        Email Address
                    </label>
                    <div class="shadow border rounded-full w-full py-3 px-3 text-brand-gray-700 bg-white flex justify-start items-center"
                         :class="{'border-red-500': errors.hasOwnProperty('contactEmail')}"
                    >
                        <i class="fas fa-at text-orange-600"></i>
                        <input class="border-none appearance-none leading-tight focus:outline-none ml-4 placeholder-brand-gray-600 w-full"
                               v-model="form.contactEmail"
                               required
                               id="contactEmail" type="email" placeholder="Your Email Address">
                    </div>
                    <p class="text-red-500 text-xs italic" v-if="errors.hasOwnProperty('contactEmail')">{{errors.contactEmail}}</p>
                </div>
                <div class="mb-4">
                    <label class="block text-brand-gray-700 text-sm font-bold mb-2 sr-only" for="contactPhone">
                        Phone Number
                    </label>
                    <div class="shadow border rounded-full w-full py-3 px-3 text-brand-gray-700 bg-white flex justify-start items-center">
                        <i class="fas fa-phone-alt text-orange-600"></i>
                        <input class="border-none appearance-none leading-tight focus:outline-none ml-4 placeholder-brand-gray-600 w-full"
                               v-model="form.contactPhone"
                               id="contactPhone" type="tel" placeholder="The best number to reach you">
                    </div>
                </div>
                <div class="mb-4">
                    <label class="block text-brand-gray-700 text-sm font-bold mb-2 sr-only" for="contactReason">
                        The reason you are getting in touch?
                    </label>
                    <div class="shadow border rounded-full w-full py-3 px-3 text-brand-gray-700 bg-white flex justify-start items-center"
                         :class="{'border-red-500': errors.hasOwnProperty('contactReason')}"
                    >
                        <i class="fas fa-cabinet-filing text-orange-600"></i>
                        <div class="relative w-full">
                            <select id="contactReason" class="ml-2 border-none appearance-none w-11/12 bg-white  hover:border-brand-gray-500 leading-tight px-2 focus:outline-none " v-model="form.contactReason">
                                <option value="">The reason you are getting in touch?</option>
                                <option v-for="reason in reasons" :key="reason.value" :value="reason.value">{{reason.label}}</option>
                            </select>
                        </div>
                    </div>
                    <p class="text-red-500 text-xs italic" v-if="errors.hasOwnProperty('contactReason')">{{errors.contactReason}}</p>
                </div>
                <div class="mb-4">
                    <label class="block text-brand-gray-700 text-sm font-bold mb-2 sr-only" for="contactState">
                        State/Province
                    </label>
                    <div class="shadow border rounded-full w-full py-3 px-3 text-brand-gray-700 bg-white flex justify-start items-center">
                        <i class="fas fa-map text-orange-600"></i>
                        <div class="relative w-full">
                            <select id="contactState" class="ml-2 border-none appearance-none w-11/12 bg-white  hover:border-brand-gray-500 leading-tight px-2 focus:outline-none " v-model="form.contactState">
                                <option value="">Your State/Province</option>
                                <option v-for="province in provinces" :key="province.abbreviation" :value="province.abbreviation">{{province.name}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="mb-4">
                    <label class="block text-brand-gray-700 text-sm font-bold mb-2 sr-only" for="contactSubject">
                        Subject
                    </label>
                    <div class="shadow border rounded-full w-full py-3 px-3 text-brand-gray-700 bg-white flex justify-start items-center"
                         :class="{'border-red-500': errors.hasOwnProperty('contactSubject')}"
                    >
                        <i class="fas fa-envelope text-orange-600"></i>
                        <input class="border-none appearance-none leading-tight focus:outline-none ml-4 placeholder-brand-gray-600 w-full"
                               v-model="form.contactSubject"
                               id="contactSubject" type="text" placeholder="Message Subject">
                    </div>
                    <p class="text-red-500 text-xs italic" v-if="errors.hasOwnProperty('contactSubject')">{{errors.contactSubject}}</p>
                </div>
                <div class="mb-4">
                    <label class="block text-brand-gray-700 text-sm font-bold mb-2 sr-only" for="contactMessage">
                        What can we help you with?
                    </label>
                    <div class="shadow border rounded-md w-full py-3 px-3 text-brand-gray-700 bg-white flex justify-start"
                         :class="{'border-red-500': errors.hasOwnProperty('contactMessage')}"
                    >
                        <i class="far fa-comments-alt text-orange-600"></i>
                        <textarea
                                id="contactMessage"
                                v-model="form.contactMessage"
                                class="ml-4 border-none appearance-none leading-tight focus:outline-none ml-4 placeholder-brand-gray-600 w-full"
                                placeholder="Give us some details about how we can help. The more the better!"
                                rows="10"></textarea>
                    </div>
                    <p class="text-red-500 text-xs italic" v-if="errors.hasOwnProperty('contactMessage')">{{errors.contactMessage}}</p>
                </div>
                <button class="btn btn-orange rounded-full mb-3 w-full font-bold focus:outline-none focus:ring" type="submit" v-show="!submitting">
                    <i class="far fa-paper-plane"></i> Send
                </button>
                <p class="btn btn-orange rounded-full mb-3 w-full font-bold focus:outline-none focus:ring" v-show="submitting">
                    <i class="far fa-spinner fa-spin"></i> Sending
                </p>
            </form>
        </div>
    </pop-open-box>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';

export default {
        name: "ContactForm",

        props: {
            provinces: {
                type: Array,
                required: true
            }
        },

        data() {
            return {
                errors: [],
                form: {
                    contactName: '',
                    contactEmail: '',
                    contactPhone: '',
                    contactReason: '',
                    contactState: '',
                    contactSubject: '',
                    contactMessage: ''
                },
                reasons: [
                    {value: "support", label: "I need more information about your course"},
                    {value: "sales", label: "I'd like to schedule an info session or review at my school"},
                    {value: "educator", label: "I'm an Educator and would like more information"},
                    {value: "other", label: "I need to discuss something else"}
                ],
                submitting: false
            };
        },

        methods: {
            async submit(callback) {
                this.submitting = true;
                try {
                    await axios.post('/contact', this.form);
                    this.popupClosed();
                    callback();
                    swal.fire("Thanks for contacting us.",'Someone from our office will get back with you soon.', 'success');
                }catch (e) {
                    if (e.hasOwnProperty('response')) {
                        if (e.response.status === 422) {
                            console.log(e.response);
                            this.errors = e.response.data.errors;

                        }
                    }else {
                        console.log(e);
                    }
                }
                this.submitting = false;
            },
            popupClosed() {
                this.errors = [];
                this.form = {
                    contactName: '',
                    contactEmail: '',
                    contactPhone: '',
                    contactReason: '',
                    contactState: '',
                    contactSubject: '',
                    contactMessage: ''
                }
            }
        }
    }
</script>

<style scoped>

</style>